import promoteDynamicContent from 'utils/comscore';
import Services from 'utils/services';

import * as HudlFeed from 'hudl-feed';
const {
  addFeedItems,
} = HudlFeed.actions.creators;

import {
  FEED_EXPLORE_TAB,
  SPORT_TIMELINE_TYPE,
} from './exploreConstants';

export const LOAD_DISCOVERY_TIMELINES_REQUEST = 'LOAD_DISCOVERY_TIMELINES_REQUEST';
export const LOAD_DISCOVERY_TIMELINES_FAIL = 'LOAD_DISCOVERY_TIMELINES_FAIL';
export const LOAD_DISCOVERY_TIMELINES_SUCCESS = 'LOAD_DISCOVERY_TIMELINES_SUCCESS';

export const INITIAL_FETCH_COMPLETE = 'INITIAL_FETCH_COMPLETE';
export const CHANGE_CURRENT_TAB = 'CHANGE_CURRENT_TAB';
export const LOAD_TAB_REQUEST = 'LOAD_TAB_REQUEST';
export const LOAD_TAB_FAIL = 'LOAD_TAB_FAIL';
export const LOAD_TAB_SUCCESS = 'LOAD_TAB_SUCCESS';

export const FETCH_MORE_REQUEST = 'FETCH_MORE_REQUEST';
export const FETCH_MORE_FAIL = 'FETCH_MORE_FAIL';
export const FETCH_MORE_SUCCESS = 'FETCH_MORE_SUCCESS';

export const FAIL_EXPLORE_TIMELINE =  'FAIL_EXPLORE_TIMELINE';
export const RECEIVE_EXPLORE_TIMELINE = 'RECEIVE_EXPLORE_TIMELINE';
export const REQUEST_EXPLORE_TIMELINE = 'REQUEST_EXPLORE_TIMELINE';

// TODO [pg] Add dismiss support for the explore timeline.
export const FAIL_DISMISS_EXPLORE_FEED_ITEM = 'FAIL_DISMISS_EXPLORE_FEED_ITEM';
export const REQUEST_DISMISS_EXPLORE_FEED_ITEM = 'REQUEST_DISMISS_EXPLORE_FEED_ITEM';
export const SUCCESS_DISMISS_EXPLORE_FEED_ITEM = 'SUCCESS_DISMISS_EXPLORE_FEED_ITEM';
// export const SHOW_CONFIRM_DISMISS_EXPLORE_FEED_ITEM,
// export const HIDE_CONFIRM_DISMISS_EXPLORE_FEED_ITEM,

// Explore timelines
function requestDiscoveryTimelines() {
  return {
    type: LOAD_DISCOVERY_TIMELINES_REQUEST,
    payload: {},
  };
}

function receiveDiscoveryTimelines(discoveryTimelines) {
  return {
    type: LOAD_DISCOVERY_TIMELINES_SUCCESS,
    payload: {
      discoveryTimelines,
    },
  };
}

function failDiscoveryTimelines() {
  return {
    type: LOAD_DISCOVERY_TIMELINES_FAIL,
    payload: {},
  };
}

export function loadDiscoveryTimelines() {
  return dispatch => {
    dispatch(requestDiscoveryTimelines());

    Services.loadDiscoveryTimelines()
      .done((response) => {
        dispatch(receiveDiscoveryTimelines(response));
      })
      .fail(() => {
        dispatch(failDiscoveryTimelines());
      });
  };
}

export function initialFetchComplete() {
  return {
    type: INITIAL_FETCH_COMPLETE,
    payload: { },
  };
}

// Explore timeline
function requestExploreTimeline(exploreTab) {
  return {
    type: REQUEST_EXPLORE_TIMELINE,
    payload: {
      exploreTab,
    },
  };
}

function failExploreTimeline(exploreTab) {
  return {
    type: FAIL_EXPLORE_TIMELINE,
    payload: {
      exploreTab,
    },
  };
}

export function receiveExploreTimeline(exploreTab, response) {
  return {
    type: RECEIVE_EXPLORE_TIMELINE,
    payload: {
      exploreTab,
      response: { feedItems: response },
    },
  };
}

export function fetchExploreTimeline(exploreTab, args = {}) {
  return dispatch => {
    dispatch(requestExploreTimeline(exploreTab));

    let serviceMethod = null;
    if (exploreTab.timelineKey === FEED_EXPLORE_TAB) {
      serviceMethod = Services.getHomeTimeline(args);
    } else {
      serviceMethod = Services.getExploreTimeline(exploreTab.timelineType, {
        count: 20,
        ...args,
      });
    }

    serviceMethod.fail(() => dispatch(failExploreTimeline(exploreTab)))
      .done(response => {
        dispatch(addFeedItems(response));
        dispatch(receiveExploreTimeline(exploreTab, response));
      });
  };
}

export function fetchMoreInExploreTimeline() {
  return (dispatch, getState) => {
    const { feedItems, explore } = getState();
    const { exploreFilters, exploreTabs, exploreTimeline } = explore;
    const { currentTab: exploreTab } = exploreTabs;

    const timelineKey = exploreTab.timelineKey;
    const existingTimeline = exploreTimeline && exploreTimeline[timelineKey] && exploreTimeline[timelineKey].feedItems;
    if (!existingTimeline || !existingTimeline.length || exploreTimeline[timelineKey].isFetching) return;

    let args = null;
    if (timelineKey === FEED_EXPLORE_TAB) {
      const lastFeedItem = feedItems[existingTimeline[existingTimeline.length - 1].feedContentId];
      const beforeDateTime = lastFeedItem && lastFeedItem.content && lastFeedItem.content.dateCreated;
      args = {
        beforeDateTime: beforeDateTime,
      };
    } else {
      args = Object.assign({}, exploreFilters);
      args.skip = existingTimeline.length;
    }

    promoteDynamicContent(exploreTabs.comScoreId);
    dispatch(fetchExploreTimeline(exploreTab, args));
  };
}

function shouldFetchExploreTimeline(state) {
  const { explore } = state;
  const { exploreTabs, exploreTimeline } = explore;
  const { currentTab: exploreTab } = exploreTabs;

  if (!(exploreTimeline && exploreTimeline[exploreTab.timelineKey])) {
    return true;
  }

  const {
    feedItems,
    isError,
    isFetching,
  } = exploreTimeline[exploreTab.timelineKey];

  return !isError && !isFetching && !feedItems;
}

export function fetchExploreTimelineIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchExploreTimeline(getState())) {
      const { explore } = getState();
      const { exploreFilters, exploreTabs } = explore;
      const { currentTab: exploreTab } = exploreTabs;

      const args = Object.assign({}, exploreFilters);
      return dispatch(fetchExploreTimeline(exploreTab, args));
    }
  };
}

// Explore tabs
function changeTab(tab) {
  return {
    type: CHANGE_CURRENT_TAB,
    payload: {
      tab,
    },
  };
}

function shouldChangeTab(state, timelineKey) {
  const { exploreTabs } = state.explore;
  const { currentTab } = exploreTabs;

  return !currentTab || timelineKey !== currentTab.timelineKey;
}

export function changeTabIfNeeded(timelineKey) {
  return (dispatch, getState) => {
    const state = getState();
    if (!shouldChangeTab(state, timelineKey)) {
      return;
    }

    const { exploreTabs } = state.explore;
    const { discoveryTimelines } = exploreTabs;
    const newTimeline = discoveryTimelines.find((item) => item.timelineKey === timelineKey);
    dispatch(changeTab(newTimeline));
    dispatch(fetchExploreTimelineIfNeeded());
  };
}

// Dismiss explore timeline items
function requestDismissExploreFeedItem(feedUserType, feedUserRelatedId, feedContentId, exploreTab) {
  return {
    type: REQUEST_DISMISS_EXPLORE_FEED_ITEM,
    payload: {
      feedUserType,
      feedUserRelatedId,
      feedContentId,
      exploreTab,
    },
  };
}

function failDismissExploreFeedItem(feedUserType, feedUserRelatedId, feedContentId, exploreTab) {
  return {
    type: FAIL_DISMISS_EXPLORE_FEED_ITEM,
    payload: {
      feedUserType,
      feedUserRelatedId,
      feedContentId,
      exploreTab,
    },
  };
}

function successDismissExploreFeedItem(feedUserType, feedUserRelatedId, feedContentId, exploreTab) {
  return {
    type: SUCCESS_DISMISS_EXPLORE_FEED_ITEM,
    payload: {
      feedUserType,
      feedUserRelatedId,
      feedContentId,
      exploreTab,
    },
  };
}

export function dismissFeedItem(feedUserType, feedUserRelatedId, feedContentId, exploreTab, isHomeTimeline) {
  return dispatch => {
    dispatch(requestDismissExploreFeedItem(feedUserType, feedUserRelatedId,
      feedContentId, exploreTab));
    if (isHomeTimeline) {
      Services.dismissFeedItem(feedContentId)
        .fail(() =>
          dispatch(failDismissExploreFeedItem(feedUserType, feedUserRelatedId, feedContentId, exploreTab)))
        .done(() =>
          dispatch(successDismissExploreFeedItem(feedUserType, feedUserRelatedId, feedContentId, exploreTab)));
    } else {
      Services.dismissProfileFeedItem(feedContentId, feedUserType, feedUserRelatedId)
        .fail(() => {
          dispatch(failDismissExploreFeedItem(feedUserType, feedUserRelatedId, feedContentId));
        })
        .done(() => {
          dispatch(successDismissExploreFeedItem(feedUserType, feedUserRelatedId, feedContentId));
        });
    }
  };
}

// TODO: Deprecate this action once we've refactored /explore to use the explore timeline reducers.
function requestFetchMore(tab) {
  return {
    type: FETCH_MORE_REQUEST,
    payload: {
      tab,
    },
  };
}

// TODO: Deprecate this action once we've refactored /explore to use the explore timeline reducers.
function failFetchhMore() {
  return {
    type: FETCH_MORE_FAIL,
    payload: {
    },
  };
}

// TODO: Deprecate this action once we've refactored /explore to use the explore timeline reducers.
function successFetchMore(items, tab) {
  return {
    type: FETCH_MORE_SUCCESS,
    payload: {
      items,
      tab,
    },
  };
}

// TODO: Deprecate this action creator once we've refactored /explore to use the explore timeline reducers.
export function fetchMore() {
  return (dispatch, getState) => {
    const { explore } = getState();
    const { exploreTabs } = explore;

    const {
      currentTab, feedItems: feedItemsObject, isFetching: isFetchingObject, noMoreResults: noMoreResultsObject,
    } = exploreTabs;

    const timelineKey = currentTab.timelineKey;
    if (!(feedItemsObject && feedItemsObject[timelineKey])) {
      return;
    }

    if (isFetchingObject && isFetchingObject[timelineKey]) {
      return;
    }

    if (noMoreResultsObject && noMoreResultsObject[timelineKey]) {
      return;
    }

    const { exploreFilters } = explore;

    const skip = Object.keys(feedItemsObject[timelineKey]).length;

    const requestData = {
      count: 20,
      skip: skip,
      ...exploreFilters,
    };

    if (currentTab.timelineType === SPORT_TIMELINE_TYPE) {
      requestData.sport = currentTab.sport;
    }

    promoteDynamicContent(exploreTabs.comScoreId);
    dispatch(requestFetchMore(currentTab));
    Services.getExploreTimeline(currentTab.timelineType, requestData)
      .fail(() => dispatch(failFetchhMore))
      .done(responseData => {
        dispatch(addFeedItems(responseData));
        dispatch(successFetchMore(responseData, currentTab));
      });
  };
}

// TODO: Deprecate this action once we've refactored /explore to use the explore timeline reducers.
function requestTabLoad(tab) {
  return {
    type: LOAD_TAB_REQUEST,
    payload: {
      tab,
    },
  };
}

// TODO: Deprecate this action once we've refactored /explore to use the explore timeline reducers.
function failTabLoad(tab) {
  return {
    type: LOAD_TAB_FAIL,
    payload: {
      tab,
    },
  };
}

// TODO: Deprecate this action once we've refactored /explore to use the explore timeline reducers.
function succeedTabLoad(items, tab) {
  return {
    type: LOAD_TAB_SUCCESS,
    payload: {
      items,
      tab,
    },
  };
}

// TODO: Deprecate this action creator once we've refactored /explore to use the explore timeline reducers.
export function changeCurrentTab(timelineKey) {
  return (dispatch, getState) => {
    const { explore } = getState();
    const { exploreTabs } = explore;
    const {
      currentTab,
      discoveryTimelines,
      feedItems: feedItemsObject,
      isFetching: isFetchingObject,
    } = exploreTabs;

    if (currentTab && timelineKey === currentTab.timelineKey) {
      return;
    }

    const timeline = discoveryTimelines.find((item) => item.timelineKey === timelineKey);
    dispatch(changeTab(timeline));

    if (feedItemsObject && feedItemsObject[timeline.timelineKey]) {
      return;
    }

    if (isFetchingObject && isFetchingObject[timeline.timelineKey]) {
      return;
    }

    const { exploreFilters } = explore;
    const requestData = {
      count: 20,
      ...exploreFilters,
    };

    if (timeline.timelineType === SPORT_TIMELINE_TYPE) {
      requestData.sport = timeline.sport;
    }

    dispatch(requestTabLoad(timeline));

    Services.getExploreTimeline(timeline.timelineType, requestData)
      .fail(() => dispatch(failTabLoad()))
      .done(responseData => {
        dispatch(addFeedItems(responseData));
        dispatch(succeedTabLoad(responseData, timeline));
      });
  };
}
